import { useState, useRef } from "react";

import { Box, Grid } from "@mui/material";

import MeetingsList from "../components/MeetingsList";
import MeetingPanel from "../components/MeetingPanel";

export const MeetingManager = () => {

    const [selectedMeetingId, setSelectedMeetingId] = useState<string | null>(null);
    const refetchMeetingsRef = useRef<{ refetch: () => void }>(null);

    const handleMeetingClick = (meetingId: string) => {
        setSelectedMeetingId(meetingId);
    };

    const handleMarkComplete = () => {
        if (refetchMeetingsRef.current) {
            refetchMeetingsRef.current.refetch();
        }
    };

    return (
        <Box display="flex" flexDirection="column" gap={2} height={"100%"}>
            <Grid container flex={1} height={"100%"}>
                <Grid size={3} height="100%">
                    <Box
                        sx={{
                            height: "100%",
                            width: "100%",
                            display: "flex",
                            flexDirection: "column",
                            gap: 2,
                            overflowY: "auto",
                            borderRight: "1px solid",
                            borderColor: "divider",
                        }}
                    >
                        <MeetingsList ref={refetchMeetingsRef} onMeetingClick={handleMeetingClick} />
                    </Box>
                </Grid>
                <Grid size={9} flex={1} height={"100%"}>
                    <Box
                        sx={{
                            borderRadius: "12px",
                            height: "100%",
                            width: "100%",
                            display: "flex",
                            flexDirection: "column",
                            gap: 2,
                            overflow: "hidden",
                        }}
                    >
                        <MeetingPanel meeting_id={selectedMeetingId || ""} onMarkComplete={handleMarkComplete} />
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};